export default __webpack_public_path__ + "static/media/css.269e1864.svg";